import { useContext } from 'react';

import { PostMessageContext } from 'component/postMessage/PostMessageContext';

export const useSdk = () => {
  const { getSdk } = useContext(PostMessageContext);
  const sdk = getSdk();

  return sdk;
};
